module.exports = __webpack_public_path__ + "img/goi-den.6fee9685.svg";